"use strict";
import {tools} from "../tools.js";
import AnchorableCollapsible from "./AnchorableCollapsible.js";
import Collapsible from "./Collapsible.js";

class CollapsibleOdaorg {

    constructor(wrapperElt=HTMLElement) {
        this.wrapper = wrapperElt
        this.collapsiblesWrap = this.wrapper.querySelector('.collapsibles')
        
        this.init()
    }

    init() {
        this.initializeCollapsibles()
    }


    initializeCollapsibles() {
        // Find all collapsible sections that were rendered server-side
        const collapsibleSections = this.collapsiblesWrap.querySelectorAll('.collapsible-component');
        
        collapsibleSections.forEach(section => {
            const btns = section.querySelectorAll('button.colbtn');
            const collapsibleElt = section.querySelector('.collapsible-wrapper');
            const collapsibleArea = section.querySelector('.collapsible-area');
            
            if (btns && collapsibleElt && collapsibleArea) {
                const dataName = section.getAttribute('data-name');
                if (dataName) {
                    new AnchorableCollapsible(dataName.trim(), section, btns, collapsibleElt, collapsibleArea);
                }
            }
        });
        
        console.log(`Initialized ${collapsibleSections.length} collapsible sections`);
    }
}


export default CollapsibleOdaorg;
